import { render, staticRenderFns } from "./InterestShowScreen.vue?vue&type=template&id=a4a1385c&"
import script from "./InterestShowScreen.vue?vue&type=script&lang=js&"
export * from "./InterestShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports